import React, { useEffect, useRef, useState } from "react";
import Sidebar from "./Sidebar";
import MainContent from "./MainContent";
import Loader from "./Loader";

const MainIndex = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [loading, setLoading] = useState(false);
    const mainRef = useRef(null);

    useEffect(() => {
        const container = mainRef.current;

        if (!container) return; // Prevent null error

        const handleScroll = () => {
            setIsScrolled(container.scrollTop > 20);
        };

        container.addEventListener("scroll", handleScroll);

        return () => {
            container.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() => {
        setLoading(true);

        const handleLoad = () => {
            setLoading(false);
        };

        if (document.readyState === "complete") {
            setLoading(false);
        } else {
            window.addEventListener("load", handleLoad);
        }

        return () => {
            window.removeEventListener("load", handleLoad);
        };
    }, []);

    return (
        <div className="App mesh-test">
            <Loader load={loading} />
            <div className="layout-wrapper">
                <Sidebar isScrolled={isScrolled} />
                <main ref={mainRef} className="dash-nav-body custom-scrollbar">
                    <MainContent />
                </main>
            </div>
        </div>
    )
}


export default MainIndex